/* tslint:disable */
import {
  Account,
  Department,
  RecordType,
  DepartmentRole
} from '../index';

declare var Object: any;
export interface GroupInterface {
  "sfdcId"?: string;
  "Accessibility_Type__c"?: string;
  "Account__c"?: string;
  "Activity_Feed__c"?: string;
  "Available_to_Communities__c"?: string;
  "Community__c"?: string;
  "CreatedById"?: string;
  "CreatedDate"?: Date;
  "CurrencyIsoCode"?: string;
  "Default__c"?: boolean;
  "Department_Group_Code__c"?: string;
  "Department__c"?: string;
  "Escalation_Feed__c"?: string;
  "Group_Code_Auto__c"?: string;
  "Group_Code_Name__c"?: string;
  "Group_Code__c"?: string;
  "IsDeleted"?: boolean;
  "LastActivityDate"?: Date;
  "LastModifiedById"?: string;
  "LastModifiedDate"?: Date;
  "LastReferencedDate"?: Date;
  "LastViewedDate"?: Date;
  "Name"?: string;
  "OwnerId"?: string;
  "PgMO_group_code__c"?: string;
  "Program__c"?: string;
  "Project__c"?: string;
  "RecordTypeId"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  account?: Account;
  department?: Department;
  recordType?: RecordType;
  departmentRoles?: DepartmentRole[];
}

export class Group implements GroupInterface {
  "sfdcId": string;
  "Accessibility_Type__c": string;
  "Account__c": string;
  "Activity_Feed__c": string;
  "Available_to_Communities__c": string;
  "Community__c": string;
  "CreatedById": string;
  "CreatedDate": Date;
  "CurrencyIsoCode": string;
  "Default__c": boolean;
  "Department_Group_Code__c": string;
  "Department__c": string;
  "Escalation_Feed__c": string;
  "Group_Code_Auto__c": string;
  "Group_Code_Name__c": string;
  "Group_Code__c": string;
  "IsDeleted": boolean;
  "LastActivityDate": Date;
  "LastModifiedById": string;
  "LastModifiedDate": Date;
  "LastReferencedDate": Date;
  "LastViewedDate": Date;
  "Name": string;
  "OwnerId": string;
  "PgMO_group_code__c": string;
  "Program__c": string;
  "Project__c": string;
  "RecordTypeId": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  account: Account;
  department: Department;
  recordType: RecordType;
  departmentRoles: DepartmentRole[];
  constructor(data?: GroupInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Group`.
   */
  public static getModelName() {
    return "Group";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Group for dynamic purposes.
  **/
  public static factory(data: GroupInterface): Group{
    return new Group(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Group',
      plural: 'Groups',
      path: 'Groups',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Accessibility_Type__c": {
          name: 'Accessibility_Type__c',
          type: 'string'
        },
        "Account__c": {
          name: 'Account__c',
          type: 'string'
        },
        "Activity_Feed__c": {
          name: 'Activity_Feed__c',
          type: 'string'
        },
        "Available_to_Communities__c": {
          name: 'Available_to_Communities__c',
          type: 'string'
        },
        "Community__c": {
          name: 'Community__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CreatedDate": {
          name: 'CreatedDate',
          type: 'Date'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "Default__c": {
          name: 'Default__c',
          type: 'boolean'
        },
        "Department_Group_Code__c": {
          name: 'Department_Group_Code__c',
          type: 'string'
        },
        "Department__c": {
          name: 'Department__c',
          type: 'string'
        },
        "Escalation_Feed__c": {
          name: 'Escalation_Feed__c',
          type: 'string'
        },
        "Group_Code_Auto__c": {
          name: 'Group_Code_Auto__c',
          type: 'string'
        },
        "Group_Code_Name__c": {
          name: 'Group_Code_Name__c',
          type: 'string'
        },
        "Group_Code__c": {
          name: 'Group_Code__c',
          type: 'string'
        },
        "IsDeleted": {
          name: 'IsDeleted',
          type: 'boolean'
        },
        "LastActivityDate": {
          name: 'LastActivityDate',
          type: 'Date'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "LastModifiedDate": {
          name: 'LastModifiedDate',
          type: 'Date'
        },
        "LastReferencedDate": {
          name: 'LastReferencedDate',
          type: 'Date'
        },
        "LastViewedDate": {
          name: 'LastViewedDate',
          type: 'Date'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "OwnerId": {
          name: 'OwnerId',
          type: 'string'
        },
        "PgMO_group_code__c": {
          name: 'PgMO_group_code__c',
          type: 'string'
        },
        "Program__c": {
          name: 'Program__c',
          type: 'string'
        },
        "Project__c": {
          name: 'Project__c',
          type: 'string'
        },
        "RecordTypeId": {
          name: 'RecordTypeId',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        account: {
          name: 'account',
          type: 'Account',
          model: 'Account',
          relationType: 'belongsTo',
                  keyFrom: 'Account__c',
          keyTo: 'sfdcId'
        },
        department: {
          name: 'department',
          type: 'Department',
          model: 'Department',
          relationType: 'belongsTo',
                  keyFrom: 'Department__c',
          keyTo: 'sfdcId'
        },
        recordType: {
          name: 'recordType',
          type: 'RecordType',
          model: 'RecordType',
          relationType: 'belongsTo',
                  keyFrom: 'RecordTypeId',
          keyTo: 'sfdcId'
        },
        departmentRoles: {
          name: 'departmentRoles',
          type: 'DepartmentRole[]',
          model: 'DepartmentRole',
          relationType: 'hasMany',
                  keyFrom: 'sfdcId',
          keyTo: 'PgMO_Groups__c'
        },
      }
    }
  }
}
